/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import type { GroupsForResourceFilterInput } from "~/generated/graphql";
import {
  FilterComparisonOperator,
  GroupsForResourceFilterByFields,
} from "~/generated/graphql";
import { coerceToStringArray } from "~/hooks/useAppliedFilters/utils";
import { createFilterByInput } from "~/utils/createFilterByInput";
import { ResourceDetailsResourceGroupsQuery } from "../../types/ResourceDetailsResourceGroupsQuery";

export const prepareResourceDetailsResourceGroupsFilter = (
  queryState: ResourceDetailsResourceGroupsQuery,
  phrase?: string
): GroupsForResourceFilterInput | undefined => {
  const createdByFilter = createFilterByInput<GroupsForResourceFilterByFields>(
    GroupsForResourceFilterByFields.CreatedBy,
    coerceToStringArray(queryState.createdBy),
    queryState.excludeCreatedBy ?? false
  );

  const dateCreatedFilter =
    queryState.startDateUTC && queryState.endDateUTC
      ? [
          {
            field: GroupsForResourceFilterByFields.CreatedAt,
            operator: FilterComparisonOperator.Ge,
            values: [queryState.startDateUTC],
          },
          {
            field: GroupsForResourceFilterByFields.CreatedAt,
            operator: FilterComparisonOperator.Le,
            values: [queryState.endDateUTC],
          },
        ]
      : [];

  const filterBy = [...createdByFilter, ...dateCreatedFilter];

  if (filterBy.length === 0 && !phrase) {
    return undefined;
  }

  return {
    phrase: phrase || undefined,
    filterBy: filterBy.length > 0 ? filterBy : undefined,
  };
};
